/* eslint-disable no-console */

import {
  Configuration,
  LogLevel,
  PublicClientApplication,
} from "@azure/msal-browser";

import Keys from "../constants/Keys";

const msalConfig: Configuration = {
  auth: {
    clientId: Keys.ClientID || "",
    authority: `https://login.microsoftonline.com/${Keys.TenantID}`,
    redirectUri: `${window.location.origin}/login`,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            break;
          case LogLevel.Info:
            break;
          case LogLevel.Verbose:
            break;
          case LogLevel.Warning:
            break;
          default:
        }
      },
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: ["User.Read"],
};

export async function loginMicrosoftRedirect(email?: string): Promise<void> {
  try {
    await msalInstance.loginRedirect(
      email
        ? { ...loginRequest, loginHint: email }
        : { ...loginRequest, prompt: "select_account" }
    );
  } catch (error) {
    console.error("Login redirect failed", error);
    throw error;
  }
}

export async function logoutMicrosoftRedirect(): Promise<void> {
  try {
    const account = msalInstance.getActiveAccount();
    if (account) {
      await msalInstance.logoutPopup({ account });
    }
    window.location.href = `${window.location.origin}/login`;
  } catch (error) {
    console.error("Logout failed", error);
    throw error;
  }
}

export async function getMicrosoftTokenRedirect(): Promise<string | null> {
  try {
    const response = await msalInstance.handleRedirectPromise();
    if (response && response.accessToken) {
      msalInstance.setActiveAccount(response.account);
      return response.accessToken;
    }

    const account =
      msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
    if (account) {
      const silentResult = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account,
      });
      return silentResult.accessToken;
    }
  } catch (error) {
    console.error("Redirect token acquisition failed", error);
  }
  return null;
}

export async function getMicrosoftTokenSilent(): Promise<string | null> {
  try {
    const account =
      msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];

    if (!account) {
      console.warn("No account found to refresh token");
      return null;
    }

    const result = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
      forceRefresh: true,
    });

    return result.accessToken;
  } catch (error) {
    console.warn("Silent token refresh failed", error);
    return null;
  }
}
